import { BlacklistAutoRuleIdSchema as r, SpotIdSchema as n, DictBlacklistConditionParamNameSchema as B, DictBlacklistStatusIdSchema as I, AdTypeIdSchema as s, DictBlacklistBanTypeIdSchema as k } from "@hprofits/shared";
import { z as e } from "zod";
import { PaginationSchema as p, paginatedList as h, SortingSchema as E } from "../common/pagination.js";
import { idListQueryParam as o, MAX_INT4_ID as c, BlacklistAutoRuleIdParamSchema as b } from "../common/params.js";
const R = e.enum([">", "<", "=", ">=", "<="]), Q = p.extend({
  ruleIds: o(r).min(1),
  // SSP feed id or name; comma-separated terms match any of them.
  search: e.string().trim().optional()
}), m = (t) => e.array(e.int().max(c).pipe(t)).readonly(), q = p.extend({
  adUnitIds: m(n),
  excludeAdUnitIds: m(n),
  adUnitTypeIds: m(s),
  search: e.string().trim().optional()
}).readonly(), x = e.object({
  ruleId: r,
  ruleName: e.string()
}).readonly(), _ = e.object({
  feedId: e.number().int(),
  feedName: e.string(),
  sspId: e.number().int(),
  sspName: e.string(),
  adUnitId: n,
  adUnitName: e.string(),
  // `ad_unit_v.ad_unit_type_id` is nullable, so the joined type name can be missing.
  adUnitTypeName: e.string().nullable(),
  profitBy: e.string().nullable(),
  rules: e.array(x).readonly()
}).readonly(), K = h(_), f = e.object({
  param: B,
  operator: R,
  value: e.number()
}).readonly(), X = e.object({
  state: I.nullable()
}).readonly(), L = e.object({
  state: e.int().max(c).pipe(I).nullable()
}).readonly(), N = e.string().trim().min(1, "name must be non-empty"), S = e.object({
  id: n,
  name: e.string(),
  adTypeId: s
}).readonly(), C = e.object({
  id: s,
  name: e.string()
}).readonly(), A = "excludeAdUnitIds requires adUnitTypeIds: a rule without ad unit types accepts adUnitIds only", U = "an ad unit can not be both in adUnitIds and in excludeAdUnitIds", z = {
  excludeWithoutTypes: A,
  includeExcludeOverlap: U
}, P = (t, a) => {
  const d = t.excludeAdUnitIds.length > 0, i = t.adUnitTypeIds.length > 0;
  d && !i && a.addIssue(A);
  const l = new Set(t.adUnitIds);
  t.excludeAdUnitIds.some((g) => l.has(g)) && a.addIssue(U);
}, D = "conditions must not repeat a param", j = (t, a) => {
  const d = /* @__PURE__ */ new Set();
  t.forEach((i, l) => {
    d.has(i.param) && a.addIssue({
      code: "custom",
      message: `${D}: ${i.param}`,
      path: ["conditions", l]
    }), d.add(i.param);
  });
}, M = "must not contain duplicate ids", u = (t) => e.array(t).readonly().refine((a) => new Set(a).size === a.length, { error: M }), y = e.object({
  name: N,
  // Both are int4 columns: a larger value would pass these schemas and fail in Postgres as a 500.
  type: e.int().max(c).pipe(k),
  checkPeriodMin: e.int().nonnegative().max(c),
  // No `.min(1)`: live rules store `{"conditions": []}` and must stay saveable.
  conditions: e.array(f).readonly(),
  action: L,
  adUnitIds: u(n),
  excludeAdUnitIds: u(n),
  adUnitTypeIds: u(s)
}).strict().readonly(), T = (t, a) => {
  P(t, a), j(t.conditions, a);
}, $ = y.superRefine(T), F = y.unwrap().extend({ ruleId: b.shape.ruleId }).readonly().superRefine(T), w = y.unwrap().omit({ adUnitIds: !0, excludeAdUnitIds: !0, adUnitTypeIds: !0 }).extend({
  id: r,
  // Read side resolves the links to names, so a client can render a rule without a second request.
  adUnits: e.array(S).readonly(),
  excludeAdUnits: e.array(S).readonly(),
  adUnitTypes: e.array(C).readonly()
}).readonly(), H = p.extend(E.shape).extend({
  sortBy: e.enum(["name", "id"]).default("name"),
  ids: o(r).optional(),
  name: e.string().trim().min(1, "name must be non-empty").optional(),
  adUnitIds: o(n).optional(),
  adUnitTypeIds: o(s).optional()
}).readonly(), V = h(w);
export {
  z as BLACKLIST_AUTO_RULE_LINK_MESSAGES,
  H as BlacklistAutoRuleListQuerySchema,
  V as BlacklistAutoRuleListSchema,
  w as BlacklistAutoRuleSchema,
  y as BlacklistAutoRuleWriteFieldsSchema,
  X as BlacklistRuleActionSchema,
  f as BlacklistRuleConditionSchema,
  R as BlacklistRuleOperatorSchema,
  _ as BlacklistSspTargetSchema,
  q as BlacklistSspTargetsPreviewQuerySchema,
  Q as BlacklistSspTargetsQuerySchema,
  K as BlacklistSspTargetsSchema,
  $ as CreateBlacklistAutoRuleSchema,
  D as DUPLICATE_CONDITION_PARAM_MESSAGE,
  M as DUPLICATE_LINK_IDS_MESSAGE,
  F as UpdateBlacklistAutoRuleSchema
};
//# sourceMappingURL=schemas.js.map
